var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _c(
        "custom-callout",
        {
          attrs: {
            "border-color": "secondary-2",
            controlled: true,
            "has-toggle": "",
            opened: _vm.opened
          },
          on: { "click:open": _vm.handleClosePanel },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _vm.actionValue == _vm.actionValues.ATTACH_SIGNED_LETTER
                    ? _c("add-letter-doc", {
                        attrs: { title: _vm.letterDocPanelTitle },
                        on: {
                          cancel: _vm.handleClosePanel,
                          save: _vm.handleSaveSignatureDoc
                        },
                        model: {
                          value: _vm.model,
                          callback: function($$v) {
                            _vm.model = $$v
                          },
                          expression: "model"
                        }
                      })
                    : _vm._e(),
                  _c("div", [
                    _vm.actionValue == _vm.actionValues.ADDITIONAL_INFO
                      ? _c(
                          "div",
                          { staticClass: "rounded p-3 mb-2 mx-0" },
                          [
                            _c("letter-details", {
                              attrs: {
                                "is-award": _vm.hasSignedLetter,
                                item: _vm.item
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _c(
                    "div",
                    [
                      _vm.actionValue == _vm.actionValues.AMENDMENT
                        ? _c("amendment-comment", {
                            on: {
                              cancel: _vm.handleClosePanel,
                              save: _vm.amendComment
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.actionValue == _vm.actionValues.AMENDMENT_HISTORY
                    ? _c("amendment-history", {
                        attrs: { history: _vm.amendmentHistory }
                      })
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "row mt-3" }, [
            _c("div", { staticClass: "col-md-2 col-12" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Tipo de Carta: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-normal color-black font-16" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("empty")(_vm.item?.letterType?.name)) +
                      " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-2 col-12" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Fecha de Creación: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-normal color-black font-16" },
                [
                  _vm._v(
                    " " + _vm._s(_vm._f("date")(_vm.item?.createdDate)) + " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-2 col-12" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Fecha Última Generación: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-normal color-black font-16" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("date")(_vm.item?.lastGenerationDateTime)) +
                      " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-2 col-12" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Fecha de Última Enmienda: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-normal color-black font-16" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("date")(_vm.item?.lastAmendmentDateTime)) +
                      " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-md-2 col-12" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Generado Por: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-normal color-black font-16" },
                [
                  _vm._v(
                    " " + _vm._s(_vm._f("empty")(_vm.item?.generatedBy)) + " "
                  )
                ]
              )
            ]),
            _c(
              "div",
              {
                staticClass:
                  "col-md-2 col-12 d-flex justify-content-md-end justify-content-start"
              },
              [
                _c("dropdown", {
                  staticClass: "actions-dropdown",
                  attrs: { items: _vm.actionItems, title: " Acciones " }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }